import dispatch from './dispatch';

export const trackNewsletterSignup = () => {
  const eventName = 'signupComplete';
  const detail = {
    eventInfo: {
      eventAction: 'Newsletter Signup',
      eventName: 'signupComplete',
      eventType: 'userEvent',
      newsletterSignup: {
        state: 'complete',
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};
